<template>
  <div class="yaliceshi-page">

    <!-- 科技感加载动画 -->
    <AiLoading :visible="loading" title="正在运行压力测试"></AiLoading>

    <div style="display: none;" @click="runAudio">隐藏播放音频按钮</div>

    <div class="header">
      <div class="logo">
        <div class="icon">
          <img src="@/assets/yali.png" alt="logo">
        </div>
        <h1>压力测试·极端风险检验</h1>
      </div>
      <p class="subtitle">模拟历史危机，检验组合生存线</p>
      <div class="lefttop-tips-container">
        <img src="@/assets/yaliceshi/icon0.png">
        <div class="lefttop-tips-title">5个极端场景</div>
      </div>
    </div>

    <div class="content">
      <div class="scenarios-container">
        <div class="scenario-section">
          <h3 class="section-title"><span class="section-icon">|</span> 历史真实情景 <span
                  class="section-desc">基于真实历史事件</span></h3>

          <div class="scenario-items" v-for="item in dataList" :key="item.type">
            <div class="scenario-item" v-if="item.category == 1" :class="{ active: selectedHistorical === item.type }"
                 @click="selectedHistorical = item.type">
              <div class="scenario-header">
                <input type="radio" name="historical" :value="item.type" v-model="selectedHistorical">
                <div class="scenario-info">
                  <!-- <img src="@/assets/yaliceshi/icon1.png"> -->
                  <div class="scenario-name">{{ item.name }}</div>
                  <!-- <div class="scenario-badge warning">{{ item.risk }}</div> -->
                </div>
              </div>
              <div class="scenario-desc">{{ item.description }}</div>
              <div class="scenario-metrics">
                <div class="metric-item">
                  <span class="metric-label">回撤</span>
                  <span class="metric-value negative">{{ item.expectedMaxDrawdown }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">恢复</span>
                  <span class="metric-value">{{ item.expectedDaysToRecover }} 天</span>
                </div>
              </div>
              <div v-if="item.assetTypeShockMultipliers" class="asset-deduction">
                <div class="asset-deduction-title">
                  <div>资产扣除比例</div>
                  <div>按资产类型冲击</div>
                </div>
                <div class="asset-deduction-grid">
                  <div class="asset-deduction-item" v-for="(value, key) in item.assetTypeShockMultipliers" :key="key">
                    <span class="asset-name">{{ getAssetTypeName(key) }}</span>
                    <span class="asset-value negative">{{ formatShockValue(value) }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="scenario-item" :class="{ active: selectedHistorical === '2008' }"
                 @click="selectedHistorical = '2008'">
              <div class="scenario-header">
                <input type="radio" name="historical" value="2008" v-model="selectedHistorical">
                <div class="scenario-info">
                  <img src="@/assets/yaliceshi/icon1.png">
                  <div class="scenario-name">2008年全球金融危机</div>
                  <div class="scenario-badge warning">极高</div>
                </div>
              </div>
              <div class="scenario-desc">次贷危机引发的全球股市暴跌，道指跌幅超54%</div>
              <div class="scenario-metrics">
                <div class="metric-item">
                  <span class="metric-label">回撤</span>
                  <span class="metric-value negative">-28.2%</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">恢复</span>
                  <span class="metric-value">224天</span>
                </div>
              </div>
            </div>

            <div class="scenario-item" :class="{ active: selectedHistorical === '2015' }"
                 @click="selectedHistorical = '2015'">
              <div class="scenario-header">
                <input type="radio" name="historical" value="2015" v-model="selectedHistorical">
                <div class="scenario-info">
                  <img src="@/assets/yaliceshi/icon2.png">
                  <div class="scenario-name">2015年A股异常波动</div>
                  <div class="scenario-badge danger">极高</div>
                </div>
              </div>
              <div class="scenario-desc">杠杆牛市崩盘，单日千股跌停，市场流动性枯竭</div>
              <div class="scenario-metrics">
                <div class="metric-item">
                  <span class="metric-label">回撤</span>
                  <span class="metric-value negative">-32.5%</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">恢复</span>
                  <span class="metric-value">356天</span>
                </div>
              </div>
            </div>

            <div class="scenario-item" :class="{ active: selectedHistorical === '2020' }"
                 @click="selectedHistorical = '2020'">
              <div class="scenario-header">
                <input type="radio" name="historical" value="2020" v-model="selectedHistorical">
                <div class="scenario-info">
                  <img src="@/assets/yaliceshi/icon3.png">
                  <div class="scenario-name">2020年疫情熔断</div>
                  <div class="scenario-badge info">中等</div>
                </div>
              </div>
              <div class="scenario-desc">新冠疫情爆发，美股4次熔断，恐慌指数VIX创新高</div>
              <div class="scenario-metrics">
                <div class="metric-item">
                  <span class="metric-label">回撤</span>
                  <span class="metric-value negative">-12.3%</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">恢复</span>
                  <span class="metric-value">67天</span>
                </div>
              </div>
            </div> -->
          </div>
        </div>

        <div class="scenario-section">
          <h3 class="section-title"><span class="section-icon">|</span> 系统假设情景 <span class="section-desc">模拟极端情况</span>
          </h3>

          <div class="scenario-items" v-for="item in dataList" :key="item.type">
            <div class="scenario-item" v-if="item.category == 2" :class="{ active: selectedHistorical === item.type }"
                 @click="selectedHistorical = item.type">
              <div class="scenario-header">
                <input type="radio" name="historical" :value="item.type" v-model="selectedHistorical">
                <div class="scenario-info">
                  <!-- <img src="@/assets/yaliceshi/icon1.png"> -->
                  <div class="scenario-name">{{ item.name }}</div>
                  <!-- <div class="scenario-badge warning">{{ item.risk }}</div> -->
                </div>
              </div>
              <div class="scenario-desc">{{ item.description }}</div>
              <div class="scenario-metrics">
                <div class="metric-item">
                  <span class="metric-label">回撤</span>
                  <span class="metric-value negative">{{ item.expectedMaxDrawdown }}</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">恢复</span>
                  <span class="metric-value">{{ item.expectedDaysToRecover }} 天</span>
                </div>
              </div>
              <div v-if="item.assetTypeShockMultipliers" class="asset-deduction">
                <div class="asset-deduction-title">
                  <div>资产扣除比例</div>
                  <div>按资产类型冲击</div>
                </div>
                <div class="asset-deduction-grid">
                  <div class="asset-deduction-item" v-for="(value, key) in item.assetTypeShockMultipliers" :key="key">
                    <span class="asset-name">{{ getAssetTypeName(key) }}</span>
                    <span class="asset-value negative">{{ formatShockValue(value) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="scenario-item" :class="{ active: selectedHistorical === 'doubleKill' }"
                 @click="selectedHistorical = 'doubleKill'">
              <div class="scenario-header">
                <input type="radio" name="historical" value="doubleKill" v-model="selectedHistorical">
                <div class="scenario-info">
                  <img src="@/assets/yaliceshi/icon4.png">
                  <div class="scenario-name">股债双杀场景</div>
                  <div class="scenario-badge success">中等</div>
                </div>
              </div>
              <div class="scenario-desc">极端情况：股票和债券同时下跌，传统分散失效</div>
              <div class="scenario-metrics">
                <div class="metric-item">
                  <span class="metric-label">回撤</span>
                  <span class="metric-value negative">-13.8%</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">恢复</span>
                  <span class="metric-value">125天</span>
                </div>
              </div>
            </div>

            <div class="scenario-item" :class="{ active: selectedHistorical === 'inflation' }"
                 @click="selectedHistorical = 'inflation'">
              <div class="scenario-header">
                <input type="radio" name="historical" value="inflation" v-model="selectedHistorical">
                <div class="scenario-info">
                  <img src="@/assets/yaliceshi/icon5.png">
                  <div class="scenario-name">通胀飙升场景</div>
                  <div class="scenario-badge warning">高</div>
                </div>
              </div>
              <div class="scenario-desc">央行激进加息，债券价格暴跌，股市承压下行</div>
              <div class="scenario-metrics">
                <div class="metric-item">
                  <span class="metric-label">回撤</span>
                  <span class="metric-value negative">-22.1%</span>
                </div>
                <div class="metric-item">
                  <span class="metric-label">恢复</span>
                  <span class="metric-value">198天</span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="tips-container">
        <div class="tips-card">
          <h3 class="tips-title">
            <i class="el-icon-info"></i>
            温馨提示
          </h3>
          <ul class="tips-list">
            <li>选择一个场景，系统将模拟该危机下的组合表现</li>
            <li>风险承受底线设为-15%，超过则测试不通过</li>
            <li>通过测试后可生成最终投资报告</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="test-btn common-btn" id="btn-start-stress-test" @click="handleStartTest">
        开始运行压力测试 <i class="el-icon-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import apiOpen from '@/api/open.js'
import AiLoading from '@/components/AiLoading.vue'
export default {
  name: 'YaliceshiPage',
  components: {
    AiLoading
  },
  data () {
    return {
      loading: false,
      selectedHistorical: '', // 默认选中2008年全球金融危机
      dataList: []
    }
  },
  watch: {
    loading (val) {
      localStorage.setItem('yaliceshi_loading', JSON.stringify({ visible: val }))
    },
    selectedHistorical (val) {
      localStorage.setItem('yaliceshi_selected', val || '')
    }
  },
  created () {
    this.runAudio()
  },
  mounted () {
    // 【修复】强制重置 loading，禁止从 localStorage 恢复旧状态（防止上一轮异常残留导致卡死）
    this.loading = false
    // 同时清除 localStorage 残留标记
    localStorage.removeItem('yaliceshi_loading')
    this.queryHistorical()
    window.addEventListener('storage', this.handleStorageChange)
    // 副屏兜底：恢复主屏已选场景
    const savedSelected = localStorage.getItem('yaliceshi_selected')
    if (savedSelected) {
      this.selectedHistorical = savedSelected
    }
  },
  beforeDestroy () {
    // 【修复】组件销毁时清理 loading 标记，防止残留
    this.loading = false
    localStorage.removeItem('yaliceshi_loading')
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    handleStorageChange (event) {
      if (event.key === 'yaliceshi_loading' && event.newValue) {
        try {
          this.loading = JSON.parse(event.newValue).visible
        } catch (e) { /* ignore */ }
      } else if (event.key === 'yaliceshi_selected') {
        this.selectedHistorical = event.newValue || ''
      }
    },
    // 播放音频
    runAudio () {
      this.playOnceAudio('/请选择测试场景.mp3')
    },
    getAssetTypeName (key) {
      const map = {
        STOCK: '股票',
        BOND: '债券',
        MIXED: '混合型',
        FUND: '基金',
        CASH: '现金',
        COMMODITY: '商品',
        REAL_ESTATE: '房地产'
      }
      return map[key] || key
    },
    formatShockValue (value) {
      if (value == null) return ''
      const num = typeof value === 'string' ? parseFloat(value) : value
      return `${(num * 100).toFixed(1)}%`
    },
    //查询历史真实情景
    queryHistorical () {
      apiOpen.getHistorical().then(res => {
        // console.log("res>>>", res);
        this.dataList = res || []
      }).catch(err => {
        this.$message.error(err.message)
      })
    },

    handleStartTest () {
      // 【修复】防御性读取 + try-catch，防止参数构造阶段未捕获异常导致 loading 无法重置
      let NewrecommendResult = null
      let allocations = []
      let riskResult = null
      try {
        NewrecommendResult = JSON.parse(localStorage.getItem('NewrecommendResult'))
        if (NewrecommendResult && NewrecommendResult.products && NewrecommendResult.products.length) {
          allocations = NewrecommendResult.products.map(item => ({
            assetCode: item.code,
            weight: item.weight
          }))
        }
        riskResult = JSON.parse(localStorage.getItem('riskResult'))
      } catch (e) {
        console.error('[压力测试] 读取localStorage数据失败', e)
      }

      if (!this.selectedHistorical) {
        this.$message.warning('请选择一个场景')
        return
      }
      if (!allocations.length) {
        this.$message.warning('未获取到资产配置数据，请重新调整权重')
        return
      }
      if (!riskResult || !riskResult.customerProfile) {
        this.$message.warning('未获取到客户风险画像，请重新完成风险评估')
        return
      }

      let params = {
        "initialCapital": Number(localStorage.getItem('initialCapital')) || 1000000,
        "allocations": allocations,
        "scenarioType": Number(this.selectedHistorical),
        "customerProfile": riskResult.customerProfile
      }
      // console.log('[压力测试] 请求参数:', JSON.stringify(params).slice(0, 200))

      this.loading = true
      apiOpen.StressTest(params).then(res => {
        this.loading = false
        // console.log('[压力测试] 请求成功 res>>>', res);
        localStorage.setItem('yaliceshiResult', JSON.stringify(res))
        this.$router.push({ name: 'YaliceshiJieguo' })
      }).catch(err => {
        this.loading = false
        const msg = (err && err.message) ? err.message : '压力测试请求失败'
        console.error('[压力测试] 请求失败:', err)
        this.$message.error(msg)
      })
      // this.$router.push({ name: 'YaliceshiJieguo' })
    }
  }
}
</script>

<style scoped lang="less">
.yaliceshi-page {
  min-height: 100vh;
  // background: linear-gradient(to right, #eff6ff, #f9fbff);
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 32px;
  box-sizing: border-box;
}

.header {
  margin-bottom: 16px;
  position: relative;
}

.lefttop-tips-container {
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(0%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  background: white;
  padding: 4px 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;

  img {
    object-fit: cover;
  }

  .lefttop-tips-title {
    font-size: 14px;
    color: #64748b;
  }
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.logo i {
  font-size: 32px;
  color: #ef4444;
}

.logo h1 {
  font-size: 28px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.icon {
  width: 36px;
  height: 36px;
  background: #fc471d;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
  }
}

.subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 24px 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 32px;
}

.scenarios-container {
  width: 100%;
  flex: 3;
  display: flex;
  /* flex-direction: column; */
  gap: 24px;
}

.scenario-section {
  width: 50%;
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #3b82f6;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-icon {
  font-size: 18px;
  font-weight: 700;
}

.section-desc {
  font-size: 12px;
  font-weight: 400;
  color: #94a3b8;
  margin-left: 8px;
}

.scenario-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.scenario-item {
  padding: 20px;
  margin: 5px 0;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.scenario-item:hover {
  border-color: #3b82f6;
}

.scenario-item.active {
  border-color: #3b82f6;
  background: rgba(59, 130, 246, 0.05);
}

.scenario-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.scenario-header input[type="radio"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.scenario-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.scenario-name {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.scenario-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: white;
}

.scenario-badge.warning {
  background: #f59e0b;
}

.scenario-badge.danger {
  background: #ef4444;
}

.scenario-badge.info {
  background: #3b82f6;
}

.scenario-badge.success {
  background: #10b981;
}

.scenario-desc {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 12px;
  line-height: 1.4;
}

.scenario-metrics {
  display: flex;
  gap: 24px;
}

.metric-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.metric-label {
  font-size: 12px;
  color: #94a3b8;
}

.metric-value {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.metric-value.negative {
  color: #ef4444;
}

.asset-deduction {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}

.asset-deduction-title {
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.asset-deduction-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.asset-deduction-item {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 8px;
}

.asset-name {
  font-size: 13px;
  color: #64748b;
}

.asset-value {
  font-size: 14px;
  font-weight: 600;
}

.asset-value.negative {
  color: #ef4444;
}

.tips-container {
  flex: 1;
}

.tips-card {
  background: #eef3ff;
  border-radius: 16px;
  padding: 6px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: fit-content;
}

.tips-title {
  font-size: 16px;
  font-weight: 600;
  color: #3b82f6;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tips-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tips-list li {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 12px;
  line-height: 1.4;
  position: relative;
  padding-left: 20px;
}

.tips-list li:before {
  content: "•";
  position: absolute;
  left: 0;
  color: #3b82f6;
  font-weight: bold;
}

.footer {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.test-btn {
  width: 300px;
  font-size: 18px;
}

.test-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.test-btn i {
  font-size: 16px;
}

/* 横屏适配 */
@media screen and (orientation: landscape) {
  .yaliceshi-page {
    padding: 8px 32px;
  }

  .header {
    margin-bottom: 0;
  }

  .logo {
    gap: 6px;

    .icon {
      width: 24px;
      height: 24px;
      border-radius: 4px;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }

  .logo h1 {
    font-size: 20px;
  }

  .logo i {
    font-size: 24px;
  }

  .subtitle {
    font-size: 11px;
    margin-bottom: 2px;
  }

  .lefttop-tips-container {
    padding: 2px 8px;
    gap: 6px;
    font-size: 11px;

    img {
      width: 16px;
      height: 16px;
    }

    .lefttop-tips-title {
      font-size: 11px;
    }
  }

  .content {
    gap: 8px;
    margin-bottom: 8px;
  }

  .scenarios-container {
    gap: 12px;
  }

  .section-title {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .section-desc {
    font-size: 10px;
  }

  .scenario-section {
    padding: 10px 12px;
  }

  .scenario-items {
    gap: 8px;
  }

  .scenario-item {
    padding: 6px 10px;
    margin: 2px 0;
    border-radius: 8px;
  }

  .scenario-header {
    margin-bottom: 4px;
    gap: 6px;
  }

  .scenario-name {
    font-size: 12px;
  }

  .scenario-desc {
    font-size: 10px;
    margin-bottom: 4px;
  }

  .scenario-metrics {
    gap: 12px;
  }

  .metric-item {
    gap: 4px;
  }

  .metric-label {
    font-size: 10px;
  }

  .metric-value {
    font-size: 12px;
  }

  .asset-deduction {
    margin-top: 6px;
    padding-top: 6px;
  }

  .asset-deduction-title {
    font-size: 10px;
    margin-bottom: 4px;
  }

  .asset-deduction-grid {
    gap: 4px;
  }

  .asset-deduction-item {
    padding: 3px 6px;
    border-radius: 4px;
  }

  .asset-name {
    font-size: 10px;
  }

  .asset-value {
    font-size: 11px;
  }

  .tips-card {
    padding: 6px 12px;
    border-radius: 8px;
  }

  .tips-title {
    font-size: 12px;
    margin-bottom: 4px;
  }

  .tips-list li {
    font-size: 10px;
    margin-bottom: 3px;
    padding-left: 14px;
  }

  .footer {
    margin-top: 6px;
  }

  .test-btn {
    padding: 16px 32px;
    font-size: 14px;
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .yaliceshi-page {
    padding: 8px 8px;
    min-height: 100vh;
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 6px;
  }

  .header {
    margin-bottom: 0;
    text-align: center;
    padding-top: 2px;
  }

  .logo {
    gap: 4px;
    justify-content: center;

    .icon {
      width: 22px;
      height: 22px;
      border-radius: 4px;

      img {
        width: 14px;
        height: 14px;
      }
    }
  }

  .logo h1 {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.5px;
    margin: 0;
  }

  .logo i {
    font-size: 16px;
  }

  .subtitle {
    font-size: 10px;
  }

  .lefttop-tips-container {
    padding: 1px 6px;
    gap: 4px;
    font-size: 9px;

    img {
      width: 12px;
      height: 12px;
    }

    .lefttop-tips-title {
      font-size: 9px;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    min-height: 0;
  }

  .scenarios-container {
    display: flex;
    flex-direction: row;
    gap: 6px;
    min-height: 0;
  }

  .scenario-section {
    flex: 1;
    padding: 6px 8px;
    border-radius: 8px;
    min-height: 0;
    overflow-y: auto;
  }

  .section-title {
    font-size: 11px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 4px;
  }

  .section-desc {
    font-size: 9px;
  }

  .scenario-items {
    gap: 4px;
    margin-bottom: 10px;
  }

  .scenario-items:empty {
    display: none;
  }

  .scenario-item {
    padding: 5px 8px;
    margin-bottom: 0;
    margin-top: 0;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .scenario-item:hover {
    border-color: #3b82f6;
    background: white;
  }

  .scenario-item.active {
    border-color: #3b82f6;
    background: rgba(59, 130, 246, 0.05);
  }

  .scenario-header {
    margin-bottom: 2px;
    gap: 4px;
  }

  .scenario-name {
    font-size: 10px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 2px;
  }

  .scenario-desc {
    font-size: 9px;
    color: #64748b;
    margin-bottom: 4px;
    height: 60px;
  }

  .scenario-metrics {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 6px;
  }

  .metric-item {
    flex: 1;
    min-width: calc(50% - 3px);
    padding: 3px 6px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    text-align: center;
    gap: 2px;
  }

  .metric-label {
    font-size: 8px;
    color: #94a3b8;
    margin-bottom: 1px;
  }

  .metric-value {
    font-size: 10px;
    font-weight: 600;
    color: #1e293b;
  }

  .asset-deduction {
    margin-top: 4px;
    padding-top: 4px;
  }

  .asset-deduction-title {
    font-size: 8px;
    margin-bottom: 3px;
  }

  .asset-deduction-grid {
    gap: 2px;
  }

  .asset-deduction-item {
    padding: 2px 4px;
    border-radius: 3px;
  }

  .asset-name {
    font-size: 8px;
  }

  .asset-value {
    font-size: 9px;
  }

  .tips-card {
    padding: 6px 10px;
    border-radius: 8px;
  }

  .tips-title {
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .tips-list li {
    font-size: 9px;
    margin-bottom: 3px;
    padding-left: 12px;
  }

  .footer {
    // display: flex;
    display: none;
    margin-top: 4px;
    padding-top: 0;
  }

  .test-btn {
    width: 100%;
    padding: 8px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 8px;
    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #7c3aed 100%);
    border: none;
    color: white;
  }

  .test-btn i {
    font-size: 12px;
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .yaliceshi-page {
    padding: 16px;
  }

  .header {
    margin-bottom: 16px;
  }

  .logo h1 {
    font-size: 20px;
  }

  .logo i {
    font-size: 24px;
  }

  .subtitle {
    font-size: 12px;
  }

  .scenario-section {
    padding: 16px;
    border-radius: 12px;
  }

  .scenario-item {
    padding: 16px;
    border-radius: 8px;
  }

  .scenario-item:hover {
    border-color: #3b82f6;
  }

  .scenario-item.active {
    border-color: #3b82f6 !important;
    background: rgba(59, 130, 246, 0.05);
  }

  .scenario-name {
    font-size: 14px;
  }

  .scenario-desc {
    font-size: 12px;
  }

  .tips-card {
    padding: 16px;
    border-radius: 12px;
  }

  .tips-list li {
    font-size: 12px;
  }

  .test-btn {
    padding: 12px 24px;
    font-size: 16px;
  }
}
</style>